// extracted by mini-css-extract-plugin
module.exports = {"whole":"osyfnlQw","half":"Rxc9bytp","third":"UHhuwpMV","quarter":"kAlViTDb","twoThirds":"ndnKQfbU","ie11GridItemSpacing":"_8Mz-pdZx"};